import { ResolvedPos } from 'prosemirror-model'
import { schema } from 'prose-core'

export const findToggleBlockDepth = ($pos: ResolvedPos) => {
  let newFromToggleBlockDepth: number
  for (let d = 1; d < $pos.depth; d++) {
    if ($pos.node(-d)?.type === schema.nodes.toggle_list) {
      newFromToggleBlockDepth = d
      break
    }
  }
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  if (typeof newFromToggleBlockDepth! !== 'undefined') {
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return newFromToggleBlockDepth!
  }
  return null
}
